import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import Spinner from "../components/Spinner";
import config from "../Config";

type UserInfo = {
  name: string;
  self_deaf: string;
  self_mute: string;
  server_deaf: string;
  server_mute: string;
};

type ChannelInfo = {
  name: string;
  users: UserInfo[];
  parent: number;
  subChannels: ChannelInfo[];
};

type ServerInfo = {
  users: UserInfo[];
  channels: ChannelInfo[];
  parent: number;
  subChannels: ChannelInfo[];
};

function Channel({
  json,
  border,
  width,
}: {
  json: ChannelInfo;
  border: number;
  width: string;
}) {
  return (
    <Box
      key={`${json.name}-top`}
      ml={3}
      pl={1}
      pr={3}
      sx={{ border, borderColor: "white", maxWidth: width }}
      textAlign="left"
    >
      <Box key={`${json.name}-box`} style={{ fontWeight: "bold" }}>
        ▸{json.name}
      </Box>
      {json.subChannels?.map((c) => (
        <Channel key={`${c.name}-channel`} json={c} border={0} width="90%" />
      ))}
      {json.users?.map((user) => {
        const mute = user.self_mute === "True" || user.server_mute === "True";
        const deaf = user.self_deaf === "True" || user.server_deaf === "True";
        return (
          <Box key={`${json.name}-${user.name}`} sx={{ margin: "15px" }}>
            {user.name}
            <Box
              key={`${json.name}-fill`}
              style={{ float: "right", color: "red" }}
            >
              {mute ? <Box key={`${json.name}-mute`}>🎤</Box> : "🎤"}
              &nbsp;&nbsp;&nbsp;
              {deaf ? <Box key={`${json.name}-deaf`}>🎧</Box> : "🎧"}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

export default function Status() {
  const [serverInfo, setServerInfo] = useState<ServerInfo>();

  const fetchStatus = () => {
    fetch(`${config.hegbotUrl}/channels`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return undefined;
      })
      .then((result) => {
        if (result) {
          setServerInfo(result?.data?.server_info);
        }
      });
  };

  useEffect(() => {
    fetchStatus();
    let fetchJob = setInterval(fetchStatus, 10_000);
    return () => {
      clearTimeout(fetchJob);
    };
  }, []);

  if (!serverInfo) {
    return <Spinner />;
  }

  const { users, channels } = serverInfo;

  Object.keys(users).forEach((channelId) => {
    channels[channelId].users = Object.values(users[channelId]);
  });

  const root = Object.values(channels).filter((c) => c.parent === -1)[0];
  const parents = Object.values(channels)
    .map((c) => c.parent)
    .filter((it) => it > -1);

  parents.forEach((_channel, index) => {
    channels[index].subChannels = Object.values(channels).filter(
      (c) => c.parent === index
    );
  });

  return <Channel json={root} width="50%" border={1} />;
}
